import { Button } from '@findigs/ui-kit/src/components/button';
import type { LoaderActionError, RouteError } from '~/types';

export type RouteErrorViewProps = {
  error: RouteError | LoaderActionError;
  dark?: boolean;
};

const ErrorMessage = ({ status }: { status: number }) => {
  const classes = 'mb-12 md:text-b-lg-regular';

  if (status == 500) {
    return (
      <p className={classes}>
        The server encountered an error and could not complete your request. If
        you need immediate assistance please contact{' '}
        <a href="mailto:support@findigs.com">support@findigs.com</a>
      </p>
    );
  }

  return (
    <p className={classes}>
      Something went wrong, please reach out to{' '}
      <a href="mailto:support@findigs.com">support@findigs.com</a> or try again.
    </p>
  );
};

export const RouteErrorView = ({ error, dark }: RouteErrorViewProps) => {
  return (
    <>
      <h1 className="text-d-md md:text-d-lg mb-6">
        Error occurred ({error.status})
      </h1>
      <ErrorMessage status={error.status} />
      <Button as="a" href="/" variant="Tonal" dark={dark}>
        Back to home
      </Button>
    </>
  );
};
